import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { INGREDIENTS } from "../data/products";
import { useStore } from "../context/StoreContext";

const Ingredients = () => {
  const { t } = useStore();
  const [open, setOpen] = useState(null);

  return (
    <section id="ingredients" className="scroll-mt-28 border-t border-[var(--line)] bg-[var(--paper)]" data-testid="ingredients-section">
      <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6 lg:py-24">
        <div className="mb-8 lg:mb-10">
          <h2 className="font-display text-4xl sm:text-5xl" data-testid="ingredients-title">{t.ingredients.title}</h2>
          <p className="mt-2 max-w-xl text-base text-[var(--muted)]">{t.ingredients.sub}</p>
        </div>

        <div className="border-t border-[var(--ink)]" data-testid="ingredients-list">
          {INGREDIENTS.map((ing) => {
            const isOpen = open === ing.key;
            return (
              <div key={ing.key} className="border-b border-[var(--line)]" data-testid={`ingredient-${ing.key}`}>
                <button
                  onClick={() => setOpen(isOpen ? null : ing.key)}
                  className="flex w-full items-center justify-between gap-4 py-4 text-left"
                  data-testid={`ingredient-toggle-${ing.key}`}
                  aria-expanded={isOpen}
                >
                  <span className="text-base font-semibold sm:text-lg">{ing.name}</span>
                  <span className="flex items-center gap-3">
                    <span className="font-display text-xl sm:text-2xl" data-testid={`ingredient-mg-${ing.key}`}>
                      {ing.mg.toLocaleString("nl-NL")} <span className="text-sm text-[var(--muted)]">mg</span>
                    </span>
                    <motion.span animate={{ rotate: isOpen ? 180 : 0 }} transition={{ duration: 0.2 }} className="text-[var(--muted)]">
                      <ChevronDown className="h-5 w-5" />
                    </motion.span>
                  </span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.25 }}
                      className="overflow-hidden"
                      data-testid={`ingredient-desc-${ing.key}`}
                    >
                      <p className="max-w-2xl pb-4 text-sm text-[var(--muted)]">{t.ingredients.items[ing.key]}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
        <p className="mt-5 text-xs text-[var(--muted)]" data-testid="ingredients-other">{t.ingredients.other}</p>
      </div>
    </section>
  );
};

export default Ingredients;
